import API from "api/API";
import useFetchData from "hooks/useFetchData";
import useAZZKULatestEditionID from "./useAZZKULatestEditionID";

export default function useAZZKUVoivodeships() {
   const edition_id = useAZZKULatestEditionID();
   return useFetchData({
      APIMethod: API.getAZZKUVoivodeships,
      cache_name: "azzku_voivodeships",
      params: [ edition_id ],
      condition: !!edition_id,
      resultDataHandler: data => data.map( v => ({
         value: v.id,
         label: v.name
      }))
   })
}